import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { ChangableComponent } from '@app/models/changable.component';
import { PlatformService } from '@core/services';
import { ErrorNotificationService } from '@shared/error-notification/error-notification.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { StepByStepWizardStep, StepByStepWizardSteps } from '../models';

@Component({
  selector: 'app-steps',
  templateUrl: './steps.component.html',
  styleUrls: ['./steps.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StepsComponent<T> extends ChangableComponent implements OnInit {
  @Input()
  public steps: StepByStepWizardSteps<T>;

  @Output()
  public stepChanged = new EventEmitter<StepByStepWizardStep<T>>();

  @Output()
  public activeStep = new EventEmitter<string>();

  public constructor(
    public errorNotificationService: ErrorNotificationService,
    public deviceService: DeviceDetectorService,
    // protected websocketService: WebsocketService,
    // public models: PaymentCheckoutWizardService,
    protected readonly cdr: ChangeDetectorRef,
    protected readonly platform: PlatformService,
  ) {
    super(cdr, platform);
  }

  public ngOnInit() {
    combineLatest([this.steps.activeStep$, this.steps.changed$])
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: ([activeStep, changed]) => {
          this.activeStep.emit(activeStep);
          this.detectChanges();
        },
        error: (error) => {
          this.errorNotificationService.captureError(error, 'OTHER-PROBLEM');
        },
      });
  }

  public get visibleSteps() {
    return this.steps.steps.filter((s) => s.visible);
  }

  public goStep(step: StepByStepWizardStep<T>) {
    this.steps.goStep(step.id);
    this.stepChanged.emit(step);
  }

  public trackByFn(index) {
    return index;
  }
}
